import { render } from "./campaigns.vue?vue&type=template&id=a1524b56"
import script from "./campaigns.vue?vue&type=script&lang=js"
export * from "./campaigns.vue?vue&type=script&lang=js"

import "./campaigns.vue?vue&type=style&index=0&id=a1524b56&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__